window.jQuery = window.$ = require('jquery')
const imagesLoaded = require('imagesloaded')

import SmoothScroll from 'smooth-scroll'
import 'gsap'
import 'parallax_background'
imagesLoaded.makeJQueryPlugin($)

$(function() {
  showProgress()

  function showProgress() {
    let loader = $('#js-opening-loader')
    let progressBar = loader.find('#js-loader-bar')
    let progressNumber = loader.find('#js-loader-number')

    let imgLoad = imagesLoaded('body')
    let imgTotal = imgLoad.images.length
    let imgLoaded = 0
    let current = 0
    let progressTimer = setInterval(updateProgress, 500 / 20)

    imgLoad.on('progress', function() {
      imgLoaded++
    })

    function updateProgress() {
      var target = (imgLoaded / imgTotal) * 100

      current += (target - current) * 0.1

      progressBar.css({ width: current + '%' })
      progressNumber.text(Math.floor(current))

      if (current >= 100) {
        clearInterval(progressTimer)

        $('body')
          .removeClass('is-loading')
          .addClass('is-loaded')

        loader.fadeOut(800, function() {
          loader.attr('aria-hidden', 'true')
          $('#js-container')
            .show()
            .removeAttr('aria-hidden')
          $('[data-parallax]').parallaxBackground()
          $('html, body').scrollTop(1)

          var loadscroll = new SmoothScroll()
          var hrefHash = location.hash
          var offset = $('#js-global-header').height()
          if (hrefHash !== '' && hrefHash !== '#pgTop' && document.getElementById(hrefHash.replace('#', '')) != null) {
            var anchor = document.querySelector(hrefHash)
            var pcOptions = { speed: 800, speedAsDuration: true, offset: 0 }
            var notPcOptions = { speed: 800, speedAsDuration: true, offset: offset }
            var ww = $(window).width()
            if (ww <= 1200) {
              setTimeout(loadscroll.animateScroll(anchor, 0, notPcOptions), 1000)
            } else {
              setTimeout(loadscroll.animateScroll(anchor, 0, pcOptions), 1000)
            }
          }
        })
      }

      if (current > 99.9) current = 100
    }
  }
})
